import { Box, Container, Flex, Text, Title } from '@mantine/core';
import type { FC, ReactNode } from 'react';

import { BackButton } from '../ui/BackButton/BackButton.tsx';

export const EventFormLayout: FC<{
  backButton?: { text: string; onClick: () => void };
  sectionSubtitle: string;
  sectionTitle: string;
  sideMenuContent: ReactNode;
  centralContent: ReactNode;
  rightContent: ReactNode;
}> = ({ backButton, sectionSubtitle, sectionTitle, sideMenuContent, centralContent, rightContent }) => {
  return (
    <Container size="lg">
      <Box py="md">
        <Flex gap="md" pos="relative">
          <Box flex="2 0 66.6666%">
            <Box py="xs">
              {backButton && (
                <Box mb="md">
                  <BackButton text={backButton.text} onClick={backButton.onClick} />
                </Box>
              )}
              <Text fw="300" size="sm">
                {sectionSubtitle}
              </Text>
              <Title order={3}>{sectionTitle}</Title>
            </Box>
            <Box h="100%" pos="absolute" style={{ transform: 'translateX(-100%) translate(-16px)' }} w="auto">
              {sideMenuContent}
            </Box>
            {centralContent}
          </Box>
          <Box flex="1 0 auto">{rightContent}</Box>
        </Flex>
      </Box>
    </Container>
  );
};
